import { Observable, observe, Scope } from 'src/3rds/cube'

// :: Types (espelham apps/server/src/bloqueio/bloqueio.types.ts)

export type SituacaoMeta = 'pendente' | 'bloqueado' | 'desbloqueado' | 'falhou' | 'simulado'

export type Bloqueio = {
    telefone: string
    waId?: string
    ativo: boolean
    motivo: string
    bloqueadoPor: string
    bloqueadoEm: string
    motivoDesbloqueio?: string
    desbloqueadoPor?: string
    desbloqueadoEm?: string
    metaSituacao: SituacaoMeta
    metaErro?: string
    metaEm?: string
    mensagensDescartadas: number
    ultimaMensagemEm?: string
    parceiro?: string
}

export type Suspeito = {
    telefone: string
    parceiro?: string
    mensagens: number
    ultima: string
    origem: 'recusadas' | 'consultas'
    bloqueado: boolean
}

/** O servidor exige o mesmo mínimo. */
export const MOTIVO_MINIMO = 10

export const BLOQUEIOS_POR_PAGINA = 15

// :: Scopes

@Observable
export class BloqueiosScope extends Scope {
    @observe() suspeitos: Suspeito[] = []
    @observe() carregandoSuspeitos = false

    @observe() somenteAtivos = true
    @observe() busca = ''
    @observe() pagina = 0
    @observe() total = 0
    @observe() bloqueios: Bloqueio[] = []
    @observe() carregandoLista = false

    // Diálogo "Bloquear número"
    @observe() bloquearAberto = false
    @observe() telefoneBloquear = ''
    @observe() motivoBloquear = ''
    @observe() erroBloquear?: string

    // Diálogo "Desbloquear"
    @observe() desbloquearAberto?: Bloqueio
    @observe() motivoDesbloquear = ''

    @observe() salvando = false

    onAtualizar = Scope.ASYNC_ACTION
    onSomenteAtivosChange = Scope.ASYNC_ACTION_ONE<boolean>()
    onBuscaChange = Scope.ASYNC_ACTION_STRING
    onPaginaChange = Scope.ASYNC_ACTION_ONE<number>()

    onAbrirBloquear = Scope.ASYNC_ACTION_STRING
    onFecharBloquear = Scope.ASYNC_ACTION
    onTelefoneBloquearChange = Scope.ASYNC_ACTION_STRING
    onMotivoBloquearChange = Scope.ASYNC_ACTION_STRING
    onConfirmarBloquear = Scope.ASYNC_ACTION

    onTentarNaMeta = Scope.ASYNC_ACTION_STRING

    onAbrirDesbloquear = Scope.ASYNC_ACTION_STRING
    onFecharDesbloquear = Scope.ASYNC_ACTION
    onMotivoDesbloquearChange = Scope.ASYNC_ACTION_STRING
    onConfirmarDesbloquear = Scope.ASYNC_ACTION
}
